const AddSemesterForm = () => {
  return <div>AddSemesterForm</div>
}

export default AddSemesterForm
